import { PriceDealType, type IPriceCategory } from 'shared/types/pricesTable';

/**
 * Оставляет категории, в которых есть хотя бы одна строка выбранного типа сделки.
 * Строки без поля `type` считаются продажей.
 */
export const filterPriceCategoriesByDealType = (
  categories: IPriceCategory[],
  dealType: PriceDealType,
): IPriceCategory[] => {
  return categories
    .map(category => ({
      ...category,
      rows: category.rows.filter(row => (row.type ?? PriceDealType.Sale) === dealType),
    }))
    .filter(category => category.rows.length > 0);
};
